!customElements.get("op-rtr-single") && customElements.define("op-rtr-single", class extends HTMLElement {
    constructor(){
        super();
        if (!this.constructor._isCloning) {
            this.constructor._isCloning = true;
            this.rtrCloned = this.cloneNode(true);
            this.rtrCloned.classList.add('rtr-cloned');
            this.parentElement?.appendChild(this.rtrCloned);
            this.constructor._isCloning = false;
        }
    }
    connectedCallback() {
        this.rtrViewer = window.rtrViewer;
        this.camera = null;
        this.isRtrStarted = false;
        this.isRtrRendered = false;
        this.progressBarCloned = this.rtrCloned.querySelector("op-progress-indicator");
        this.staticImage = this.querySelector("[data-static-img]");
        this.packagingImage = this.querySelector("[data-packaging-img]");
        if (!this.rtrViewer) {
            console.error("RTRViewer is not available.");
            return;
        }

        this.containerSel = this.dataset.containerSelector;
        this.container = this.containerSel ? this.querySelector(this.containerSel) : null;
        this.desktopBreakpoint = parseInt(this.dataset.desktopBreakpoint) || 1024;
        this.stopTimeoutDelay = parseInt(this.dataset.stopTimeoutDelay) || 0;

        if (!this.container) {
            console.error(`Container ${this.containerSel} not found.`);
            return;
        }

        this.variantBarcode = this.container.dataset.defaultVariantBarcode;
        this.desktopBackground = this.formatImageUrl(this.container.dataset.desktopBackground);
        this.mobileBackground = this.formatImageUrl(this.container.dataset.mobileBackground);
        this.defaultBackground = this.formatImageUrl(this.container.dataset.defaultBackground);
        this.showBackground = this.container.dataset.showBackground === "true";
    
        // Blocks
        this.contentBlocks = this.querySelectorAll("[data-content-block-id]");
    
        // Swiper
        this.swiperElement = this.querySelector(`.swiper`);

        if (this.swiperElement) {
            let attrValue = this.swiperElement.getAttribute('data-slide-for-view');
            this.slideForView = attrValue !== null ? parseInt(attrValue, 10) : "auto";
        }

        this.slides = this.querySelectorAll('.swiper-slide');
        this.currSlide = this.slides[0];
        
        this.pagination = this.querySelectorAll('.swiper-pagination-bullet');
        if(this.pagination){
            this.pagination.forEach(pagination => {
                pagination.addEventListener('click', this.pagination_clickHandler);
            });
        }

        this.slides.forEach(slide => {
            slide.addEventListener('click', this.slide_clickHandler);
            
        });
    
        // Positions
        this.rtrPositions = JSON.parse(this.querySelector("[data-rtr-position-obj]")?.textContent.trim() || "{}");
                
        // Init object with settings
        this.initInput = {
            data: {
                selector: this.containerSel,
                id: {
                    type: 'upc', // moco or token
                    value: this.variantBarcode, // or any other valid UPC, MoCo or token
                },
                backgroundPath: this.defaultBackground,
                settings: {
                    autoResetCamera: true,
                    autoRotateCamera: false,
                    autoRotateSpeed: 20,
                    backgroundFit: 'fill',
                    boundingArea: {
                        topLeft: {
                            x: 0,
                            y: 0,
                        },
                        bottomRight: {
                            x: 1,
                            y: 1,
                        },
                    },
                    boundingFit: 'auto',
                    cameraAnimationTime: 0.3,
                    cameraRotationInitial: {
                        phi: 0,
                        theta: 0,
                    },
                    cameraRotationReset: {
                        phi: 0,
                        theta: 0,
                    },
                    clearColor: '#ffffff',
                    gestures: {
                        mouse: {
                            left: 'rotate',
                            middle: 'none',
                            right: 'pan',
                            wheel: 'none',
                        },
                        touches: {
                            one: 'rotate',
                            two: 'dolly-pan',
                            three: 'none',
                        },
                    },
                    lensesName: undefined,
                    lensesOpacity: 1,
                    orbitPoint: true,
                    qualityMoving: 4,
                    qualityStill: 5,
                    scrollInteraction: false,
                    showBackground: this.showBackground,
                    showEnvironment: false,
                    transmission: true,
                }
            },
            callbacks: {
                onRendered: () => this.handleOnRendered(),
                onError: (error) => console.error("RTRViewer error:", error),
            },
        };

        window.addEventListener('resize', this.window_resizeHandler);
        
        if (this.isDesktop()) {
            // Desktop BoundingArea
            this.initInput.data.settings.boundingArea.topLeft.x = 0;
            this.initInput.data.settings.boundingArea.bottomRight.y = 1;
            // Desktop BackgroundPath
            this.initInput.data.backgroundPath = this.desktopBackground || this.defaultBackground;
        } else {
            this.initInput.data.backgroundPath = this.mobileBackground || this.desktopBackground || this.defaultBackground;
        }

        this.buttonSwiper = window.Swiper ? new window.Swiper(this.swiperElement, {
            slidesPerView: this.slideForView,
            slidesPerGroupAuto: true,
            navigation: {
                nextEl: '[data-swiper-btn-next]',
                prevEl: '[data-swiper-btn-prev]',
            },
            updateOnWindowResize: true,
            loop: false,
            grabCursor: true,
            centeredSlidesBounds: true,
            simulateTouch: true,
            slideToClickedSlide: true
        }) : null;

        this.stopTimeoutId = null;

        this.intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.startRtr();
                    if (this.progressBarCloned) {
                        this.progressBarCloned.startLoading();
                    }
                } else {
                    this.scheduleRtrStop();
                }
            });
        });

        this.intersectionObserver.observe(this.container);

        if (!this.buttonSwiper) {
            console.warn("Swiper is not available.");
        }
        this.classList.add('tw-invisible');
    }

    disconnectedCallback () {
        this.slides?.forEach(slide => {
            slide.removeEventListener('click', this.slide_clickHandler);
        });

        window.removeEventListener('resize', this.window_resizeHandler);
        this.intersectionObserver?.disconnect();
        
        if (this.isRtrStarted) {
            this.stopRtr();
        }

        this.buttonSwiper?.destroy();
    }

    formatImageUrl (path) {
        return path ? URL.parse(path, window.location.origin)?.toString() : null;
    }

    handleOnRendered () {

        setTimeout(() => {
            this.rtrCloned.remove();
            this.classList.remove('tw-invisible'); 
        }, 500);

        this.camera = this.rtrViewer.getCameraControls();
        if (this.progressBarCloned) {
            this.progressBarCloned.setAttribute("value", this.progressBarCloned.getAttribute("max") || "100");
        }
        this.classList.remove("rtr-loading");

        if (this.slides.length > 0) {
            this.slides.forEach((slide, index) => {
                slide.toggleAttribute("data-active", index === 0);
            });

            // this.selectRtrFeature(this.slides[0].dataset.rtrCameraPosition);
            this.handleSlideChange(this.currSlide);
        } else {
            this.contentBlocks.forEach((block, index) => {
                block.toggleAttribute("data-active", index === 0);
            });
        }

        this.isRtrRendered = true;

        this.activityCallback(
        () => this.classList.add('rtr-suspended'),
        () => this.classList.remove('rtr-suspended'),
        10000, this);

        this.rotationCallback(5000, this);
        this.staticImage?.classList.add('tw-hidden');

    }

    // moveCameraToFeature (feature) {
    //     const isDesktop = this.isDesktop();
    //     const pos = (isDesktop ? feature.pos : feature.posMob) || [0, 0, 0];
    //     const target = (isDesktop ? feature.target : feature.targetMob) || [0, 0, 0];
        
    //     this.camera.setPosition(...pos, true);
    //     this.camera.moveTo(...target, true);
    // }

    // selectRtrFeature (featureId) {
    //     const features = this.rtrPositions?.features;
    //     const selFeature = features ? features[featureId] : null;
        
    //     if (!selFeature) {
    //         console.warn(`Feature with ID ${featureId} not found.`);
    //         return;
    //     }

    //     if (!this.camera) {
    //         console.warn("Camera not initialized.");
    //         return;
    //     }
        
    //     this.moveCameraToFeature(selFeature);
    // }

    moveCameraToCustomPosition (slide) {
        let pos, target;
        const isDesktop = this.isDesktop();
        const isTablet = this.isTablet();
        const posDesktop = slide.dataset.pos;
        const targetDesktop = slide.dataset.target;
        const posTablet = slide.dataset.posTablet;
        const targetTablet = slide.dataset.targetTablet;
        const posMob = slide.dataset.posMob;
        const targetMob = slide.dataset.targetMob;

        const parseCoords = str => (str || '0,0,0').split(',').map(Number);
        const validCoords = coords => coords?.trim();

        if (isDesktop && validCoords(posDesktop) && validCoords(targetDesktop)) {
            pos = parseCoords(posDesktop);
            target = parseCoords(targetDesktop);
        } 
        else if (isTablet && validCoords(posTablet) && validCoords(targetTablet)) {
            pos = parseCoords(posTablet);
            target = parseCoords(targetTablet);
        } 
        else {
            pos = parseCoords(posMob);
            target = parseCoords(targetMob);
        }

        console.log('Moving camera to position :', pos, 'and target:', target);
        if (!this.camera) {
            console.warn("Camera not initialized.");
            return;
        }
        
        this.camera.setLookAt(pos[0], pos[1], pos[2], target[0], target[1], target[2], true);

    }

    isPackagingSlide (slide) {
        return slide?.dataset?.slideType === "packaging";
    }

    togglePackagingOverlay (slide) {
        if (!this.packagingImage) return;

        const shouldShowPackaging = this.isPackagingSlide(slide);
        this.packagingImage.classList.toggle("tw-hidden", !shouldShowPackaging);
        this.classList.toggle("packaging-active", shouldShowPackaging);
    }

    handleSlideChange (slide) {
        if (!slide) {
            return;
        }

        this.currSlide = slide;
        this.updateContentBlock(slide.dataset.blockId);
        this.togglePackagingOverlay(slide);

        if (!this.isPackagingSlide(slide)) {
            this.moveCameraToCustomPosition(slide);
        }
    }


    pagination_clickHandler = () => {
        if (!this.isRtrRendered) {
            return;
        }

        const currSlide = this.querySelector('.swiper-slide-active');

        if (!currSlide) {
            console.warn("Current slide not found.");
            return;
        }

        this.slides.forEach(slide => {
            slide.toggleAttribute("data-active", slide === currSlide);
        });

        this.handleSlideChange(currSlide);
        this.buttonSwiper?.slideTo(this.buttonSwiper.clickedIndex);
    }

    slide_clickHandler = (event) => {
        let currSlide;

        if (!this.isRtrRendered) {
            return;
        }

        this.slides.forEach(slide => {
            if (slide.toggleAttribute("data-active", slide === event.currentTarget)) {
                currSlide = slide;
            }
        });

        if (!currSlide) {
            console.warn("Current slide not found.");
            return;
        }

        this.handleSlideChange(currSlide);

        this.buttonSwiper?.slideTo(this.buttonSwiper.clickedIndex); // Ensures direct navigation
    }
    
    updateContentBlock (currentBlockId) {
        this.contentBlocks.forEach(block => {
            block.toggleAttribute("data-active", block.dataset.contentBlockId === currentBlockId);
        });
    }
    
    isDesktop () {
        return window.innerWidth >= this.desktopBreakpoint;
    }

    isTablet (){
        return window.innerWidth < this.desktopBreakpoint && window.innerWidth >= 768;
    }

    startRtr () {
        if (this.stopTimeoutId) {
            clearTimeout(this.stopTimeoutId);
        }

        if (window.rtrViewerMV) {
            window.rtrViewerMV.isInitialized()
                .then(initialized => {
                    if (initialized) {
                        window.rtrViewerMV.dispose();
                    }
                })
                .catch(err => {
                    console.error("Error initializing rtrViewerMV:", err);
                });
        }

        if (this.rtrViewer.isInitialized()) {
            if (this.isRtrStarted) return;
            this.rtrViewer.dispose();
        }

        this.rtrViewer.init(this.initInput);
        this.isRtrStarted = true;
    }

    stopRtr () {
        if (this.isRtrStarted) {
            this.rtrViewer.dispose();
            this.isRtrStarted = false;
            this.isRtrRendered = false;
        }
    }

    activityCallback(inactivityCallback, activityCallback, timeout = 3000, container) {
        let timer;
        const activityEvents = ['mousemove', 'keydown', 'click', 'touchend'];

        const resetTimer = () => {
            clearTimeout(timer);
            timer = setTimeout(inactivityCallback, timeout);
            if (typeof activityCallback === "function") activityCallback()
        };
        
        const addEvents = () => activityEvents.forEach(event => {container.addEventListener(event, resetTimer)});
        const removeEvents = () => activityEvents.forEach(event => container.removeEventListener(event, resetTimer));

        if (container) {
            const observer = new IntersectionObserver(entries => entries.forEach(entry => entry.isIntersecting ? addEvents() : removeEvents()));
            observer.observe(container);
        } else {
            addEvents();
        }


        resetTimer();
    }

    rotationCallback(timeout, container) {
        let timer;
        this.back = true;

        const resetTimer = () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                if (this.back && this.currSlide && !this.isPackagingSlide(this.currSlide)) {
                    this.moveCameraToCustomPosition(this.currSlide);
                }
            }, timeout);
        }

        const mouseDown = () => {
            this.back = false;
            resetTimer();
        }

        const mouseUp = () => {
            this.back = true;
            resetTimer();
        }

        const touchEnd = () => {
            this.back = true;
            resetTimer();
        }

        const addEvents = () => {
            container.addEventListener("mousedown", mouseDown);
            container.addEventListener("mouseup", mouseUp);
            container.addEventListener("touchend", touchEnd);
        };
        const removeEvents = () => {
            container.removeEventListener("mousedown", mouseDown);
            container.removeEventListener("mouseup", mouseUp);
            container.removeEventListener("touchend", touchEnd);
        }

        if(container) {
            const observer = new IntersectionObserver(entries => entries.forEach(entry => entry.isIntersecting ? addEvents() : removeEvents()));
            observer.observe(container);
        } else {
            addEvents();
        }

        resetTimer();
    }

    scheduleRtrStop () {
        if (this.stopTimeoutDelay === 0) {
            this.stopRtr();
            return;
        }

        this.stopTimeoutId = setTimeout(() => {
            this.stopRtr();
        }, 5000);
    }

    window_resizeHandler = () => {
      const isDesktop = this.isDesktop();

      const bgPath = isDesktop ? this.desktopBackground : this.mobileBackground;

      const boundingArea = {
        topLeft: {
          x: 0,
          y: 0,
        },
        bottomRight: {
          x: 1,
          y: 1,
        },
      }
        
      this.rtrViewer.setBackgroundPath(bgPath || this.desktopBackground || this.defaultBackground);
      this.rtrViewer.setBoundingArea(boundingArea);
    }
});
